import React from "react";

import StandPhotoForm from "../forms/stand-photo-form";


const StandPhotoBlock = ({ stand, callback }) => {

    const {
        id,
        exhibitor  : title,
        file_photo : standPhoto
    } = stand;

    return(
        <div className="stand-photo-block">
            <h3>{ title }</h3>
            <StandPhotoForm
                id = { id }
                callback = { callback }
                standPhoto = { standPhoto }
            />
        </div>
    );
};

export default StandPhotoBlock;
